/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authsignupalreadyaccount4Inputs */



/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Authsignupalreadyaccount4Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authsignupalreadyaccount4 = /** @type {((inputs?: Authsignupalreadyaccount4Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authsignupalreadyaccount4Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("Already have an account?")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("Vous avez déjà un compte ?")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("Sie haben bereits ein Konto?")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("已經有帳戶？")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("이미 계정이 있나요?")
	return /** @type {LocalizedString} */ ("すでにアカウントをお持ちですか？")
});
export { authsignupalreadyaccount4 as "authSignUpAlreadyAccount" }